import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {
        chart: {
            type: 'column',
            zoomType: 'x'
        },
        legend: {
            enabled: true
        },
        title: {
            text: 'Consumo médio borracha por medida de pneu'
        },
        xAxis: {
            categories: [],
            title: {
                text: ''
            }
        },
        plotOptions: {
            pareto: {
                marker: {
                    enabled: false
                }
            },
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    color: 'blue',
                    format: '{point.y:.0f}',
                    rotation: 270
                }
            }
        },
        yAxis: [{
            title: {
                text: 'Kg'
            }
        }, {
            title: {
                text: 'Ciclos'
            },
            minPadding: 0,
            maxPadding: 0,

            opposite: true,

        }],
        series: []
    };


export default function RoitreadExtrusionPerTireSizesParetoChart(prop) {
    const { series } = prop;

    if (series) {
        let categories = [];
        let bTotal = [];
        let sCiclos = [];

        let x = 0;
        series.map(i => {

            categories.push(i.Description);
            bTotal.push( i.AvgExtrusoraConsumo );
            sCiclos.push([x,i.Ciclos]);
            x++;

        })

        console.log('bTotal', bTotal);
        console.log('sCiclos', sCiclos);

        config = {
            ...config,
            xAxis: {
                categories: categories,
                title: {
                    text: ''
                }
            },

            series: [ {
                type: 'column',
                name: 'Medida',
                data: bTotal
            },
                {
                    type: 'line',
                    name: '# Ciclos',
                    data: sCiclos,

                    marker: {
                        enabled: false
                    },
                    states: {
                        hover: {
                            lineWidth: 0
                        }
                    },
                    enableMouseTracking: false
                }
            ]
        }

    }





    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
